import React, { useEffect, useState } from 'react';
import { Form, Input, Space, Modal, Button, Typography, Switch, InputNumber } from 'antd';

const { Title } = Typography;

const ModalForm = ({ title, formItems, open, toggleModal, apiCall }) => {
  const [form] = Form.useForm();

  useEffect(() => {
    console.log('form Reset');
    form.resetFields();
  }, [open]);

  const renderedForm = item => {
    const { label, name, type } = item;

    switch (type) {
      case 'switch':
        return (
          <Form.Item key={name} label={label} name={name} valuePropName="checked">
            <Switch checkedChildren="Yes" unCheckedChildren="No" />
          </Form.Item>
        );
      case 'number':
        return (
          <Form.Item
            key={name}
            label={label}
            name={name}
            valuePropName="checked"
            rules={[
              {
                required: true,
                message: 'Please do not leave blank',
              },
            ]}
          >
            <InputNumber
              style={{ width: '100%' }}
              min={1}
              formatter={value => Number(value).toLocaleString('en-US')}
              parser={value => Number(value.toString().split(',').join(''))}
            />
          </Form.Item>
        );
      case 'input':
      default:
        return (
          <Form.Item
            key={name}
            label={label}
            name={name}
            rules={[
              {
                required: true,
                message: 'Please do not leave blank',
              },
            ]}
          >
            <Input />
          </Form.Item>
        );
    }
  };

  const formItemLayout = {
    labelCol: {
      xs: { span: 24 },
      sm: { span: 10 },
    },
    wrapperCol: {
      xs: { span: 24 },
      sm: { span: 24 },
    },
  };
  return (
    <Modal
      title={
        <Title level={3} style={{ margin: '0 0 2rem 0', textAlign: 'center' }}>
          {title}
        </Title>
      }
      open={open}
      closable={false}
      centered
      footer={null}
      style={{
        width: "max-content"
      }}
    >
      <Form
        onFinish={apiCall}
        form={form}
        labelCol={{
          span: 8,
        }}
        size={'middle'}
        labelWrap = {false}
        // layout='vertical'
        {...formItemLayout}
      >
        {formItems.map(item => renderedForm(item))}
        <Form.Item>
          <Space
            style={{
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'end',
              alignItems: 'center',
              marginTop: '2rem',
            }}
          >
            <Button type="default" onClick={toggleModal}>
              Cancel
            </Button>
            <Button type="primary" htmlType="submit">
              Submit
            </Button>
          </Space>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default ModalForm;
